import { InboxOutlined, QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Alert, Divider, Input, Modal, Select, Switch, Timeline, Tooltip } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadFile } from 'antd/lib/upload/interface';
import moment from 'moment';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import MenuSidebarAndContainer from '../../../components/MenuSidebarAndContainer/menu-sidebar-and-container.component';
import BaseDatePicker from '../components/base-date-picker';
import BaseInput from '../components/base-input';
import BaseSelect from '../components/base-select';
import HeaderContainer from '../components/header';
import { widthEnum } from '../types/tamanho-enum';
import FileListComponent from './components/file-list';
import ModalCadastroDeConta from './components/modal-create-conta';
import ModalRepetir from './components/modal-repetir';
import { TimelineHistorico } from './components/time-line-historico';
import Styles from './despesa.module.scss';
import useFetchDataDespesaAndState from './hooks/use-fetch-data-form';
import useUploadFile from './hooks/use-file';
import useRecurrence from './hooks/use-recurrence';
import useSaveConta from './hooks/use-save-conta';
import { UploadFileWithDesc } from './types/file-interface';
import { formattedDate } from '../../../util/format';
import { useDimissAlert } from './hooks/use-dimiss-alert';

export function DespesaCreate() {
	const history = useHistory();
	const {
		fornecedor,
		centroCusto,
		categoria,
		subCategoria,
		tipoPagamentoList,
		conta,
		despesa,
		isEdit,
		despesaHistory,
		despesaObservacaoHistory,
		setDespesa,
		createOrPatchDespesa,
		fetchContas,
	} = useFetchDataDespesaAndState();
	const [activeTab, setActiveTab] = useState<'OBSERVACOES' | 'ANEXOS' | 'HISTORICO'>('OBSERVACOES');
	const { fileList, onChangeUpload, onDelete, downloadFile, updateDescription, syncUploads, onDeleteById } = useUploadFile(despesa, setDespesa);
	const { isModalCadastroConta, setisModalCadastroConta } = useSaveConta();
	const { isRecurring, isRecurrenceModalOpen, setIsRecurring, setRecurrenceModalOpen } = useRecurrence();
	const { isParcelamento, isVisibleAlert, setIsVisibleAlert, isModalConfirm, setIsModalConfirm } = useDimissAlert(despesa, isEdit);

	const handleSalvar = async () => {
		const ok = await syncUploads();
		if (!ok) return;
		createOrPatchDespesa();
	};

	return (
		<MenuSidebarAndContainer itemMenuSelected={14}>
			<HeaderContainer>
				<div className={Styles.header}>
					<h3 className={Styles.title} style={{ cursor: 'pointer' }} onClick={() => history.goBack()}>
						Contas a Pagar
					</h3>
					<h3 className={Styles.title}>
						<RightOutlined style={{ margin: '0 3px' }} size={16} rev={undefined} />
						Nova Despesa
					</h3>
				</div>
			</HeaderContainer>
			<div className={Styles.container_lancamento}>
				<span className={Styles.titulo_lancamento}>INFORMAÇÕES DO LANÇAMENTO</span>
				{isParcelamento && isVisibleAlert && (
					<Alert
						message={
							<>
								<span role="img" aria-label="parcelamento">
									📌
								</span>{' '}
								Esta despesa é a{' '}
								<strong>
									parcela {despesa.numeroParcela} de {despesa.totalParcelas}
								</strong>{' '}
								de um parcelamento.
							</>
						}
						type="warning"
						showIcon
						closable
						onClose={() => setIsVisibleAlert(false)}
						style={{ margin: '12px 0' }}
					/>
				)}
				<div className={Styles.input_list}>
					<div className={Styles.container_input}>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option?.props?.title?.toLowerCase().includes(input.toLowerCase())
							}
							value={despesa?.fornecedor?.id}
							onChange={(item) => setDespesa({ ...despesa, fornecedor: { ...despesa?.fornecedor, id: item } })}
							placeholder="Selecione um fornecedor"
							labelConfig={{
								label: 'Selecione um fornecedor',
								required: true,
								tooltip: true,
								tooltipText: 'Selecione um fornecedor já cadastrado ou cadastre um novo fornecedor.',
								addonRight: '+ Novo fornecedor',
								addonRightClick: () => history.push('/contas-a-pagar/cadastro-fornecedor'),
							}}
							width={widthEnum.lg}
						>
							{fornecedor?.map((item) => (
								<Select.Option key={item.id} value={item.id} title={item.nomeFantasia}>
									<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
										<span>{item.nomeFantasia}</span>
										<span
											onClick={(e) => {
												e.stopPropagation();
												history.push(`/contas-a-pagar/cadastro-fornecedor/${item.id}`);
											}}
											style={{
												marginLeft: 12,
												color: '#1890ff',
												cursor: 'pointer',
												fontSize: 12,
											}}
										>
											Editar
										</span>
									</div>
								</Select.Option>
							))}
						</BaseSelect>
						<BaseDatePicker
							value={despesa?.dhCompetencia ? moment(despesa?.dhCompetencia) : undefined}
							onChange={(item) => setDespesa({ ...despesa, dhCompetencia: item.toDate() })}
							labelConfig={{
								label: 'Data de competência',
								required: true,
								tooltip: true,
								tooltipText: 'Data que representa o período em que a despesa foi gerada. Utilizada para controle contábil, independente do pagamento.',
							}}
							width={'350px'}
							placeholder="Selecione uma data"
						/>
						<BaseInput
							value={despesa?.dsDespesa}
							maxLength={100}
							max={100}
							onChange={(item) => setDespesa({ ...despesa, dsDespesa: item.target.value })}
							labelConfig={{ label: 'Descrição da despesa', required: true, tooltip: true, tooltipText: 'Descreva o motivo ou natureza da despesa.' }}
							width={widthEnum.lg}
							placeholder="Descrição da despesa"
						/>
						<BaseInput
							max={99999999.99}
							min={0}
							value={despesa?.vlDespesa}
							onChange={(item) => setDespesa({ ...despesa, vlDespesa: Number(item.target.value) })}
							type="number"
							labelConfig={{ label: 'Valor', required: true, tooltip: true, tooltipText: 'Informe o valor total da despesa.' }}
							width={widthEnum.md}
							placeholder="R$ 0,00 "
						/>
					</div>
					<div className={Styles.container_input}>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={despesa?.centroCusto?.id}
							onChange={(item) => setDespesa({ ...despesa, centroCusto: { ...despesa?.centroCusto, id: item } })}
							placeholder="Centro de custo"
							labelConfig={{ label: 'Centro de custo', required: true, tooltip: true, tooltipText: 'Selecione o centro de custo vinculado a essa despesa.' }}
							width={widthEnum.lg}
						>
							{centroCusto?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.dsCentroCusto}
								</Select.Option>
							))}
						</BaseSelect>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={despesa?.categoria?.id}
							onChange={(item) => setDespesa({ ...despesa, categoria: { ...despesa?.categoria, id: item } })}
							placeholder="Categoria"
							labelConfig={{ label: 'Categoria', required: true, tooltip: true, tooltipText: 'Tipo principal da despesa. Ex: Salário, Serviços.' }}
							width={widthEnum.mdLg}
						>
							{categoria?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.dsCategoria}
								</Select.Option>
							))}
						</BaseSelect>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={despesa?.subCategoria?.id}
							onChange={(item) => setDespesa({ ...despesa, subCategoria: { ...despesa?.subCategoria, id: item } })}
							disabled={!despesa?.categoria}
							placeholder="Subcategoria"
							labelConfig={{ label: 'Subcategoria', required: true, tooltip: true, tooltipText: 'Subdivisão da categoria. Ex: Salário, Serviços, etc.' }}
							width={widthEnum.lg}
						>
							{subCategoria?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.dsSubCategoria}
								</Select.Option>
							))}
						</BaseSelect>
						<BaseSelect
							value={despesa?.tpCusto}
							showSearch
							filterOption={(input, option) => option.props.key.toLowerCase().includes(input.toLowerCase())}
							onChange={(item) => setDespesa({ ...despesa, tpCusto: item })}
							placeholder="Tipo de custo"
							labelConfig={{ label: 'Tipo de custo', required: true, tooltip: true, tooltipText: 'Selecione o tipo de custo da despesa.' }}
							width={widthEnum.lg}
						>
							<Select.Option key="Fixo" value="Fixo">
								Fixo
							</Select.Option>
							<Select.Option key="Variável" value="Variável">
								Variável
							</Select.Option>
						</BaseSelect>
					</div>
				</div>
			</div>
			<div className={Styles.container_lancamento}>
				<span className={Styles.titulo_lancamento}>CONDIÇÕES DE PAGAMENTO</span>
				{!isEdit && (
					<div className={Styles.switchWrapper}>
						<Switch
							checked={isRecurring}
							onChange={(checked) => {
								setIsRecurring(checked);
								if (checked) {
									setRecurrenceModalOpen(true);
								} else {
									setDespesa({
										...despesa,
										recorrenciaDto: { qtdRepetir: 0, qtdFrequencia: undefined },
									});
								}
							}}
						/>
						<label className={Styles.inputLabel}>
							Repetir lançamento
							<Tooltip
								title={
									'Aqui você define quantas vezes quer repetir a despesa e o intervalo (em dias, semanas, meses ou anos). Será criada uma nova despesa para cada repetição.'
								}
							>
								<QuestionCircleOutlined style={{ fontSize: 15, paddingLeft: 3 }} rev={undefined} />
							</Tooltip>
						</label>
					</div>
				)}
				<div className={Styles.input_list}>
					<div className={Styles.container_input}>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.props.key.toLowerCase().includes(input.toLowerCase())}
							disabled={isParcelamento ? true : false}
							value={despesa?.tpParcelamento}
							onChange={(item) => setDespesa({ ...despesa, tpParcelamento: item })}
							labelConfig={{ label: 'Tipo de pagamento', required: true, tooltip: true, tooltipText: 'Selecione o tipo de pagamento da despesa.' }}
							placeholder="Selecione o tipo de pagamento"
							width={widthEnum.mdLg}
						>
							<Select.Option key="A Vista" value="A Vista">
								À vista
							</Select.Option>
							<Select.Option key="Parcelado" value="Parcelado">
								Parcelado
							</Select.Option>
						</BaseSelect>
						{despesa?.tpParcelamento === 'Parcelado' && !isEdit && (
							<>
								<BaseInput
									type="number"
									min={1}
									max={100}
									value={despesa.parcelamentoDto?.qtdRepetir ?? ''}
									onChange={(e) =>
										setDespesa({
											...despesa,
											parcelamentoDto: {
												...despesa.parcelamentoDto,
												qtdRepetir: Number(e.target.value),
											},
										})
									}
									labelConfig={{
										label: 'N° de parcelas',
										required: true,
										tooltip: true,
										tooltipText:
											'Informe em quantas vezes a despesa será parcelada. O valor total será dividido automaticamente entre as parcelas no momento do salvamento.',
									}}
									placeholder="Ex: 5"
									width={widthEnum.sm}
								/>

								<BaseSelect
									value={despesa.parcelamentoDto?.qtdFrequencia}
									onChange={(value) =>
										setDespesa({
											...despesa,
											parcelamentoDto: {
												...despesa.parcelamentoDto,
												qtdFrequencia: value,
											},
										})
									}
									placeholder="Frequência"
									labelConfig={{ label: 'Intervalo', required: true }}
									width={widthEnum.md}
								>
									<Select.Option value="DIAS">Dias</Select.Option>
									<Select.Option value="SEMANAS">Semanas</Select.Option>
									<Select.Option value="MESES">Meses</Select.Option>
									<Select.Option value="ANOS">Anos</Select.Option>
								</BaseSelect>
							</>
						)}
						<BaseDatePicker
							value={despesa?.dhVencimento ? moment(despesa?.dhVencimento) : undefined}
							onChange={(item) => setDespesa({ ...despesa, dhVencimento: item.toDate() })}
							labelConfig={{ label: 'Data de vencimento', required: true, tooltip: true, tooltipText: 'Insira a data de vencimento da despesa.' }}
							placeholder="Selecione"
							width={widthEnum.md}
						/>
						<BaseSelect
									showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={despesa?.tipoPagamento?.id}
							onChange={(item) => setDespesa({ ...despesa, tipoPagamento: { ...despesa?.tipoPagamento, id: item } })}
							labelConfig={{ label: 'Forma de pagamento', required: true, tooltip: true, tooltipText: 'Selecione a forma de pagamento da despesa.' }}
							placeholder="Selecione a forma"
							width={widthEnum.mdLg}
						>
							{tipoPagamentoList?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.descricao}
								</Select.Option>
							))}
						</BaseSelect>
						<BaseSelect
							showSearch
							filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
							value={despesa?.conta?.id}
							onChange={(item) => setDespesa({ ...despesa, conta: { ...despesa?.conta, id: item } })}
							labelConfig={{
								label: 'Conta',
								tooltip: true,
								required: true,
								tooltipText: 'Selecione uma conta já cadastrada ou cadastre uma nova conta.',
								addonRight: '+ Nova conta',
								addonRightClick: () => {
									setisModalCadastroConta(true);
								},
							}}
							placeholder="Selecione"
							width={widthEnum.md}
						>
							{conta?.map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.descricao}
								</Select.Option>
							))}
						</BaseSelect>
						{!isEdit && !despesa?.recorrenciaDto?.qtdRepetir && !despesa?.tpParcelamento?.includes('Parcelado') && (
							<div className={Styles.checkboxWrapper} style={{ width: widthEnum.md }}>
								<input
									onChange={(e) => {
										if (!e.target.checked) {
											setDespesa({ ...despesa, flPago: false, statusDespesa: { ...despesa?.statusDespesa, id: null } });
										} else {
											setDespesa({ ...despesa, flPago: e.target.checked, statusDespesa: { ...despesa?.statusDespesa, id: 3 } });
										}
									}}
									type="checkbox"
									id="checkbox"
									style={{ cursor: 'pointer' }}
								/>
								<label htmlFor="checkbox" style={{ cursor: 'pointer' }} className={Styles.inputLabel}>
									Marcar como pago
								</label>
							</div>
						)}
					</div>
				</div>
				{despesa?.flPago && (
					<>
						<Divider />
						<div className={Styles.input_list}>
							<div className={Styles.container_input}>
								<BaseInput
									min={0}
									value={despesa?.vlPago}
									onChange={(item) => setDespesa({ ...despesa, vlPago: Number(item.target.value) })}
									type="number"
									labelConfig={{ label: 'Valor pago', required: despesa?.flPago ? true : false, tooltip: true, tooltipText: 'Valor efetivamente pago.' }}
									width={widthEnum.md}
									placeholder="R$ 0,00 "
								/>
								<BaseDatePicker
									value={despesa?.dhPagamento ? moment(despesa?.dhPagamento) : undefined}
									onChange={(item) => setDespesa({ ...despesa, dhPagamento: item.toDate() })}
									labelConfig={{ label: 'Data de pagamento', required: true, tooltip: true, tooltipText: 'Data em que o pagamento foi realizado.' }}
									placeholder="Selecione uma data"
									width={widthEnum.mdLg}
								/>
								<BaseInput
									value={despesa?.vlJuros}
									onChange={(item) => setDespesa({ ...despesa, vlJuros: Number(item.target.value) })}
									type="number"
									labelConfig={{ label: 'Juros', tooltip: true, tooltipText: 'Informe o valor de juros, se houver.' }}
									width={widthEnum.md}
									placeholder="R$ 0,00 "
								/>
								<BaseInput
									value={despesa?.vlMulta}
									onChange={(item) => setDespesa({ ...despesa, vlMulta: Number(item.target.value) })}
									type="number"
									labelConfig={{ label: 'Multa', tooltipText: 'Informe o valor de multa, se houver.' }}
									width={widthEnum.md}
									placeholder="R$ 0,00 "
								/>
								<BaseInput
									value={despesa?.vlDesconto}
									onChange={(item) => setDespesa({ ...despesa, vlDesconto: Number(item.target.value) })}
									type="number"
									labelConfig={{ label: 'Desconto', tooltipText: 'Informe o valor de desconto concedido no pagamento.' }}
									width={widthEnum.md}
									placeholder="R$ 0,00 "
								/>
							</div>
						</div>
					</>
				)}
			</div>
			<div className={Styles.container_observacoes}>
				<div className={Styles.tabs}>
					<div className={`${Styles.tab} ${activeTab === 'OBSERVACOES' ? Styles.active : ''}`} onClick={() => setActiveTab('OBSERVACOES')}>
						OBSERVAÇÕES
					</div>
					<div className={`${Styles.tab} ${activeTab === 'ANEXOS' ? Styles.active : ''}`} onClick={() => setActiveTab('ANEXOS')}>
						ANEXOS
					</div>
					{isEdit && (
						<div
							className={`${Styles.tab}  ${activeTab === 'HISTORICO' ? Styles.active : ''}`}
							onClick={() => {
								despesaHistory && setActiveTab('HISTORICO');
							}}
						>
							HISTÓRICO
						</div>
					)}
				</div>

				{activeTab === 'OBSERVACOES' && (
					<div className={Styles.observacoesContent}>
						<label className={Styles.inputLabel} htmlFor="observacoes">
							Observações
						</label>
						<textarea
							maxLength={100}
							onChange={(e) => setDespesa({ ...despesa, observacao: e.target.value })}
							id="observacoes"
							className={Styles.observacoesInput}
							value={despesa?.observacao}
							placeholder="Descreva observações relevantes..."
						/>
						<small className={Styles.inputHelper}>Descreva as observações relevantes sobre esse lançamento financeiro (limitado a 100 caracteres).</small>

						{despesaObservacaoHistory?.length > 0 && (
							<>
								<Divider />
								<label className={Styles.inputLabel}>Histórico de observações</label>
								<div className={Styles.historicoObservacoesScrollable}>
									<Timeline mode="left" reverse>
										<Timeline.Item className={Styles.firstItem}>
											<div className={Styles.timelineFirst}>
												Primeira vez cadastrada em <br></br>
												{formattedDate(despesa?.dataCriacao)}
											</div>
										</Timeline.Item>
										{despesaObservacaoHistory.map((item, idx) => (
											<Timeline.Item key={idx}>
												<div className={Styles.timelineItemContent}>
													<div className={Styles.timelineHeader}>
														<span className={Styles.timelineCampo}>Data: {formattedDate(item.dataAlteracao)}</span>
													</div>
													<div className={Styles.timelineBody}>
														<span className={Styles.timelineValor}>Observação: {item.valorAntigo || 'vazio'}</span>
														<span className={Styles.timelineMeta}>
															por <strong>{item.usuario}</strong>
														</span>
													</div>
												</div>
											</Timeline.Item>
										))}
									</Timeline>
								</div>
							</>
						)}
					</div>
				)}

				{activeTab === 'ANEXOS' && (
					<div className={Styles.observacoesContent}>
						<>
							<label className={Styles.inputLabel}>Anexar arquivos</label>
							<Dragger
								listType="text"
								multiple
								customRequest={({ file, onSuccess }) => {
									setTimeout(() => onSuccess?.('ok'), 0);
								}}
								onChange={onChangeUpload}
								onRemove={onDelete}
								fileList={fileList as UploadFile[]}
								itemRender={(originNode, file, files, { remove }) => (
									<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
										<div
											style={{
												minWidth: 200,
												maxWidth: 200,
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{originNode}
										</div>

										<div style={{ flex: 1, padding: 10 }}>
											<Input
												placeholder="Descrição do arquivo"
												maxLength={100}
												value={(file as UploadFileWithDesc).description}
												onChange={(e) => updateDescription(file.uid, e.target.value)}
											/>
										</div>
										{/* <a onClick={() => remove?.(file)}>Excluir</a> */}
									</div>
								)}
							>
								<p className="ant-upload-drag-icon">
									<InboxOutlined rev={undefined} />
								</p>
								<p className="ant-upload-text">Clique ou arraste o arquivo para esta área</p>
								<p className="ant-upload-hint">Tamanho máximo do arquivo suportado: 20MB</p>
							</Dragger>
						</>
						{despesa?.arquivosDespesa?.length > 0 && isEdit && (
							<>
								<label className={Styles.inputLabel} htmlFor="observacoes">
									Anexos da despesa
								</label>
								<FileListComponent onDelete={onDeleteById} arquivos={despesa?.arquivosDespesa ?? []} onDownload={downloadFile} />
							</>
						)}
					</div>
				)}
				{activeTab === 'HISTORICO' && isEdit && (
					<div className={Styles.observacoesContent}>
						<TimelineHistorico despesaHistory={despesaHistory} dataCriacao={despesa?.dataCriacao} />
					</div>
				)}
			</div>
			<div className={Styles.footerActions}>
				<button
					className={Styles.cancelBtn}
					onClick={() => {
						if (isEdit) return setIsModalConfirm(true);
						history.goBack();
					}}
				>
					Voltar
				</button>
				<button className={Styles.saveBtn} onClick={() => handleSalvar()}>
					Salvar
				</button>
			</div>
			<ModalRepetir
				isRecurrenceModalOpen={isRecurrenceModalOpen}
				despesa={despesa}
				setDespesa={setDespesa}
				setRecurrenceModalOpen={setRecurrenceModalOpen}
				setIsRecurring={setIsRecurring}
			/>
			<ModalCadastroDeConta isModalCadastroConta={isModalCadastroConta} setisModalCadastroConta={setisModalCadastroConta} fetchContas={fetchContas} />
			<Modal
				visible={isModalConfirm}
				title="Deseja cancelar as alterações?"
				okText="Sim, cancelar"
				onOk={() => {
					setIsModalConfirm(false);
					history.goBack();
				}}
				onCancel={() => setIsModalConfirm(false)}
			>
				<p>Ao sair agora, todas as alterações feitas serão perdidas. Tem certeza de que deseja cancelar?</p>
			</Modal>
		</MenuSidebarAndContainer>
	);
}
